import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockOpenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock_open"}/>
}
